export type SemaforoColor = 'verde' | 'amarillo' | 'rojo' | 'neutro';

export const DIAS_ALERTA_AMARILLO = 5;

export function getSemaforoColor(
    fechaVencimientoSRT: string | null | undefined,
    fechaPresentacionVisita?: string | null
): SemaforoColor {
    if (!fechaVencimientoSRT) return 'neutro';

    const referencia = fechaPresentacionVisita ? new Date(fechaPresentacionVisita) : new Date();
    const vencimiento = new Date(fechaVencimientoSRT);

    const referenciaUTC = Date.UTC(
        referencia.getUTCFullYear(),
        referencia.getUTCMonth(),
        referencia.getUTCDate()
    );
    const vencimientoUTC = Date.UTC(
        vencimiento.getUTCFullYear(),
        vencimiento.getUTCMonth(),
        vencimiento.getUTCDate()
    );

    const diasRestantes = (vencimientoUTC - referenciaUTC) / (1000 * 60 * 60 * 24);

    if (diasRestantes >= DIAS_ALERTA_AMARILLO) return 'verde';
    if (diasRestantes > 0) return 'amarillo';
    return 'rojo';
}
